import { render } from "./TradeList.vue?vue&type=template&id=1cb3ecd1&scoped=true&ts=true"
import script from "./TradeList.vue?vue&type=script&lang=ts"
export * from "./TradeList.vue?vue&type=script&lang=ts"

import "./TradeList.vue?vue&type=style&index=0&id=1cb3ecd1&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1cb3ecd1"]])

export default __exports__